import { createFileRoute } from '@tanstack/react-router';
import { DeviceOverviewTab } from '@/features/devices/components';

export const Route = createFileRoute('/_app/devices/$deviceId/overview')({
  component: DeviceOverviewTab,
});
